import { render, staticRenderFns } from "./NavBarComponents.vue?vue&type=template&id=20857cc6"
import script from "./NavBarComponents.vue?vue&type=script&lang=js"
export * from "./NavBarComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports